import { getOverride } from '@confluence/meta';

export function getContentId() {
	let id = getOverride('content-id');
	if (!+id) {
		id = getOverride('page-id');
	}
	if (!+id) {
		id = '0'; // ensure we always return "0" or an actual id.
	}
	return id;
}

/**
 * Check if need to disable nested table
 * @param $node jQuery object which is the current node in editor
 * @returns {boolean}
 */
export function shouldDisableNestedTable($node) {
	return $node.closest(TABLE_CONTAINER_FILTER).length > 0;
}

/**
 * @param $node jQuery object which is the current node in editor
 * @param tablepicker should be AJS.Rte.TablePicker
 * @param editor should be window.tinymce.activeEditor object
 */
export function disableNestedTable($node, tablepicker, editor) {
	if (shouldDisableNestedTable($node)) {
		//disable insert table button
		tablepicker.disable();
		//change tooltip of insert table button
		document
			.getElementById('rte-button-insert-table')
			.setAttribute(
				'data-tooltip',
				editor.translate('tinymce.tablepicker.nested_table_unsupported'),
			);
	}
}

export const TABLE_CONTAINER_FILTER = 'BLOCKQUOTE, TABLE.confluenceTable, LI';
